import React from 'react';

export const AiSolutionsIcon = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <mask
      id="mask0_47_790"
      style={{ maskType: 'alpha' }}
      maskUnits="userSpaceOnUse"
      x="0"
      y="0"
      width="24"
      height="24"
    >
      <rect width="24" height="24" fill="currentColor" />
    </mask>
    <g mask="url(#mask0_47_790)">
      <path
        d="M6.5 11L12 2L17.5 11H6.5ZM17.5 22C16.25 22 15.1875 21.5625 14.3125 20.6875C13.4375 19.8125 13 18.75 13 17.5C13 16.25 13.4375 15.1875 14.3125 14.3125C15.1875 13.4375 16.25 13 17.5 13C18.75 13 19.8125 13.4375 20.6875 14.3125C21.5625 15.1875 22 16.25 22 17.5C22 18.75 21.5625 19.8125 20.6875 20.6875C19.8125 21.5625 18.75 22 17.5 22ZM3 21.5V13.5H11V21.5H3ZM17.5 20C18.2 20 18.7917 19.7583 19.275 19.275C19.7583 18.7917 20 18.2 20 17.5C20 16.8 19.7583 16.2083 19.275 15.725C18.7917 15.2417 18.2 15 17.5 15C16.8 15 16.2083 15.2417 15.725 15.725C15.2417 16.2083 15 16.8 15 17.5C15 18.2 15.2417 18.7917 15.725 19.275C16.2083 19.7583 16.8 20 17.5 20ZM5 19.5H9V15.5H5V19.5ZM10.05 9H13.95L12 5.85L10.05 9Z"
        fill="currentColor"
      />
    </g>
  </svg>
);

export const DocsIcon = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 -960 960 960"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="m384-335 43-43-101-102 101-101-43-43-144 144.5L384-335Zm192 0 145-145-144-144-43 43 101 101-102 102 43 43ZM180-120q-24.75 0-42.37-17.63Q120-155.25 120-180v-600q0-24.75 17.63-42.38Q155.25-840 180-840h205q5-35 32-57.5t63-22.5q36 0 63 22.5t32 57.5h205q24.75 0 42.38 17.62Q840-804.75 840-780v600q0 24.75-17.62 42.37Q804.75-120 780-120H180Zm0-60h600v-600H180v600Zm324.5-627.5Q515-818 515-832t-10.5-24.5Q494-867 480-867t-24.5 10.5Q445-846 445-832t10.5 24.5Q466-797 480-797t24.5-10.5ZM180-180v-600 600Z"
      fill="currentColor"
    />
  </svg>
);

export const SubmissionsIcon = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <mask
      id="mask0_47_448"
      style={{ maskType: 'alpha' }}
      maskUnits="userSpaceOnUse"
      x="0"
      y="0"
      width="24"
      height="24"
    >
      <rect width="24" height="24" fill="currentColor" />
    </mask>
    <g mask="url(#mask0_47_448)">
      <path
        d="M12.1338 3.83203L6.20879 7.25703L12.1338 10.682L18.0588 7.25703L12.1338 3.83203ZM3.13379 15.807V7.85703C3.13379 7.49036 3.22129 7.15703 3.39629 6.85703C3.57129 6.55703 3.81712 6.31536 4.13379 6.13203L11.1338 2.10703C11.3005 2.0237 11.463 1.95703 11.6213 1.90703C11.7796 1.85703 11.9505 1.83203 12.1338 1.83203C12.3171 1.83203 12.4921 1.85703 12.6588 1.90703C12.8255 1.95703 12.9838 2.0237 13.1338 2.10703L20.1338 6.13203C20.4505 6.31536 20.6963 6.55703 20.8713 6.85703C21.0463 7.15703 21.1338 7.49036 21.1338 7.85703V11.832H19.1338V8.93203L12.1088 12.982L8.62129 10.957L5.13379 8.93203V15.782L11.1338 19.257V21.557L4.13379 17.532C3.81712 17.3487 3.57129 17.107 3.39629 16.807C3.22129 16.507 3.13379 16.1737 3.13379 15.807Z"
        fill="currentColor"
      />
    </g>
    <path d="M19 21H17V19H15V17H17V15H19V17H21V19H19V21Z" fill="currentColor" />
  </svg>
);

export const SystemMonitoringIcon = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <mask
      id="mask0_47_298"
      style={{ maskType: 'alpha' }}
      maskUnits="userSpaceOnUse"
      x="0"
      y="0"
      width="24"
      height="24"
    >
      <rect width="24" height="24" fill="currentColor" />
    </mask>
    <g mask="url(#mask0_47_298)">
      <path
        d="M7.5 6C7.08333 6 6.72917 6.14583 6.4375 6.4375C6.14583 6.72917 6 7.08333 6 7.5C6 7.91667 6.14583 8.27083 6.4375 8.5625C6.72917 8.85417 7.08333 9 7.5 9C7.91667 9 8.27083 8.85417 8.5625 8.5625C8.85417 8.27083 9 7.91667 9 7.5C9 7.08333 8.85417 6.72917 8.5625 6.4375C8.27083 6.14583 7.91667 6 7.5 6ZM7.5 16C7.08333 16 6.72917 16.1458 6.4375 16.4375C6.14583 16.7292 6 17.0833 6 17.5C6 17.9167 6.14583 18.2708 6.4375 18.5625C6.72917 18.8542 7.08333 19 7.5 19C7.91667 19 8.27083 18.8542 8.5625 18.5625C8.85417 18.2708 9 17.9167 9 17.5C9 17.0833 8.85417 16.7292 8.5625 16.4375C8.27083 16.1458 7.91667 16 7.5 16ZM4 3H20C20.2833 3 20.5208 3.09583 20.7125 3.2875C20.9042 3.47917 21 3.71667 21 4V11C21 11.2833 20.9042 11.5208 20.7125 11.7125C20.5208 11.9042 20.2833 12 20 12H4C3.71667 12 3.47917 11.9042 3.2875 11.7125C3.09583 11.5208 3 11.2833 3 11V4C3 3.71667 3.09583 3.47917 3.2875 3.2875C3.47917 3.09583 3.71667 3 4 3ZM5 5V10H19V5H5ZM4 13H20C20.2833 13 20.5208 13.0958 20.7125 13.2875C20.9042 13.4792 21 13.7167 21 14V21C21 21.2833 20.9042 21.5208 20.7125 21.7125C20.5208 21.9042 20.2833 22 20 22H4C3.71667 22 3.47917 21.9042 3.2875 21.7125C3.09583 21.5208 3 21.2833 3 21V14C3 13.7167 3.09583 13.4792 3.2875 13.2875C3.47917 13.0958 3.71667 13 4 13ZM5 15V20H19V15H5Z"
        fill="currentColor"
      />
    </g>
  </svg>
);

export const AnalyticsIcon = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <mask
      id="mask0_47_201"
      style={{ maskType: 'alpha' }}
      maskUnits="userSpaceOnUse"
      x="0"
      y="0"
      width="24"
      height="24"
    >
      <rect width="24" height="24" fill="currentColor" />
    </mask>
    <g mask="url(#mask0_47_201)">
      <path
        d="M7.4 22L6 20.6L12.9 13.675L16.4 17.175L21.575 12L23 13.425L16.4 20L12.9 16.5L7.4 22ZM4 21C3.45 21 2.97917 20.8042 2.5875 20.4125C2.19583 20.0208 2 19.55 2 19V5C2 4.45 2.19583 3.97917 2.5875 3.5875C2.97917 3.19583 3.45 3 4 3H18C18.55 3 19.0208 3.19583 19.4125 3.5875C19.8042 3.97917 20 4.45 20 5V9.2H4V21ZM4 7.2H18V5H4V7.2Z"
        fill="currentColor"
      />
    </g>
  </svg>
);

export const SupportIcon = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <mask
      id="mask0_47_807"
      style={{ maskType: 'alpha' }}
      maskUnits="userSpaceOnUse"
      x="0"
      y="0"
      width="24"
      height="24"
    >
      <rect width="24" height="24" fill="currentColor" />
    </mask>
    <g mask="url(#mask0_47_807)">
      <path
        d="M12 22L11.75 19H11.5C9.13333 19 7.125 18.175 5.475 16.525C3.825 14.875 3 12.8667 3 10.5C3 8.13333 3.825 6.125 5.475 4.475C7.125 2.825 9.13333 2 11.5 2C12.6833 2 13.7875 2.22083 14.8125 2.6625C15.8375 3.10417 16.7375 3.7125 17.5125 4.4875C18.2875 5.2625 18.8958 6.1625 19.3375 7.1875C19.7792 8.2125 20 9.31667 20 10.5C20 11.75 19.7958 12.95 19.3875 14.1C18.9792 15.25 18.4208 16.3167 17.7125 17.3C17.0042 18.2833 16.1625 19.175 15.1875 19.975C14.2125 20.775 13.15 21.45 12 22ZM14 18.35C15.1833 17.35 16.1458 16.1792 16.8875 14.8375C17.6292 13.4958 18 12.05 18 10.5C18 8.68333 17.3708 7.14583 16.1125 5.8875C14.8542 4.62917 13.3167 4 11.5 4C9.68333 4 8.14583 4.62917 6.8875 5.8875C5.62917 7.14583 5 8.68333 5 10.5C5 12.3167 5.62917 13.8542 6.8875 15.1125C8.14583 16.3708 9.68333 17 11.5 17H14V18.35ZM11.475 15.975C11.7583 15.975 12 15.875 12.2 15.675C12.4 15.475 12.5 15.2333 12.5 14.95C12.5 14.6667 12.4 14.425 12.2 14.225C12 14.025 11.7583 13.925 11.475 13.925C11.1917 13.925 10.95 14.025 10.75 14.225C10.55 14.425 10.45 14.6667 10.45 14.95C10.45 15.2333 10.55 15.475 10.75 15.675C10.95 15.875 11.1917 15.975 11.475 15.975ZM10.75 12.8H12.25C12.25 12.3 12.3 11.95 12.4 11.75C12.5 11.55 12.8167 11.1833 13.35 10.65C13.65 10.35 13.9 10.025 14.1 9.675C14.3 9.325 14.4 8.95 14.4 8.55C14.4 7.7 14.1125 7.0625 13.5375 6.6375C12.9625 6.2125 12.2833 6 11.5 6C10.7667 6 10.15 6.20417 9.65 6.6125C9.15 7.02083 8.8 7.51667 8.6 8.1L10 8.65C10.0833 8.36667 10.2417 8.0875 10.475 7.8125C10.7083 7.5375 11.05 7.4 11.5 7.4C11.95 7.4 12.2875 7.525 12.5125 7.775C12.7375 8.025 12.85 8.3 12.85 8.6C12.85 8.88333 12.7667 9.1375 12.6 9.3625C12.4333 9.5875 12.2333 9.81667 12 10.05C11.4167 10.55 11.0625 10.9458 10.9375 11.2375C10.8125 11.5292 10.75 12.05 10.75 12.8Z"
        fill="currentColor"
      />
    </g>
  </svg>
);

export const LogoIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 32 32"
      fill="none"
    >
      <path
        d="M30.0373 13.9354C29.2255 13.9329 28.5751 13.2849 28.5801 12.4782C28.5826 11.6739 29.2432 11.0184 30.0449 11.0235C30.8541 11.026 31.5046 11.6815 31.497 12.4883C31.4919 13.3026 30.8541 13.9354 30.0373 13.9354Z"
        fill="white"
      />
      <path
        d="M24.4608 26.55C24.4557 27.3441 23.8104 27.9795 23.0112 27.982C22.1943 27.9845 21.5389 27.3189 21.5489 26.4945C21.559 25.7079 22.217 25.0625 23.0061 25.0625C23.8305 25.0625 24.4684 25.7155 24.4608 26.55Z"
        fill="white"
      />
      <path
        d="M30.0373 17.4457C29.2255 17.4407 28.5801 16.7953 28.5801 15.986C28.5801 15.1842 29.2431 14.5287 30.0473 14.5313C30.8516 14.5338 31.507 15.1918 31.4995 15.9986C31.4944 16.8104 30.8516 17.4482 30.0373 17.4457Z"
        fill="white"
      />
      <path
        d="M19.4954 0.500007C20.3123 0.502529 20.9526 1.14038 20.9501 1.95472C20.9476 2.75897 20.2845 3.41951 19.4879 3.41699C18.6887 3.41447 18.0307 2.7514 18.0332 1.94715C18.0357 1.13282 18.6761 0.497486 19.4954 0.500007Z"
        fill="white"
      />
      <path
        d="M27.9791 23.0427C27.9665 23.8369 27.3136 24.4823 26.527 24.4798C25.7152 24.4773 25.0345 23.7865 25.0572 22.9898C25.0799 22.1881 25.7606 21.5326 26.5497 21.5553C27.3665 21.5779 27.9943 22.2309 27.9791 23.0427Z"
        fill="white"
      />
      <path
        d="M24.4607 5.46252C24.4607 6.27685 23.8178 6.92479 23.0085 6.92479C22.2043 6.92479 21.5488 6.26929 21.5488 5.46252C21.5463 4.65827 22.1993 4.00781 23.0085 4.00781C23.8304 4.00781 24.4607 4.64062 24.4607 5.46252Z"
        fill="white"
      />
      <path
        d="M30.0264 20.9483C29.2121 20.9433 28.5667 20.2903 28.5793 19.4835C28.5919 18.6793 29.2575 18.0238 30.0541 18.0313C30.8558 18.0389 31.5088 18.7095 31.4987 19.5112C31.4861 20.3306 30.8483 20.9533 30.0264 20.9483Z"
        fill="white"
      />
      <path
        d="M27.9796 8.9653C27.9821 9.77963 27.3392 10.4276 26.53 10.4276C25.7232 10.4276 25.0627 9.77711 25.0576 8.97538C25.0526 8.18122 25.7156 7.51815 26.5199 7.51563C27.3367 7.51311 27.9771 8.15096 27.9796 8.9653Z"
        fill="white"
      />
      <path
        d="M19.4935 28.5859C20.3078 28.5859 20.9532 29.2288 20.9507 30.0381C20.9507 30.8399 20.2876 31.5029 19.491 31.5029C18.6918 31.5029 18.0312 30.8373 18.0312 30.0381C18.0363 29.2238 18.6792 28.5834 19.4935 28.5859Z"
        fill="white"
      />
      <path
        d="M14.5293 30.023C14.5318 29.2087 15.1697 28.5809 15.9915 28.586C16.8033 28.591 17.4412 29.2364 17.4361 30.0457C17.4286 30.8474 16.763 31.5055 15.9688 31.4954C15.1621 31.4878 14.5268 30.8348 14.5293 30.023Z"
        fill="white"
      />
      <path
        d="M14.5293 1.93234C14.5344 1.12052 15.1747 0.500317 15.9991 0.507881C16.8109 0.512923 17.4437 1.16086 17.4336 1.9752C17.4235 2.77188 16.7454 3.43495 15.9563 3.4173C15.1546 3.39965 14.5243 2.74415 14.5293 1.93234Z"
        fill="white"
      />
      <path
        d="M11.0147 1.95748C11.0096 1.14062 11.6449 0.507812 12.4643 0.507812C13.2736 0.507812 13.9265 1.15827 13.9215 1.96C13.9164 2.74912 13.2383 3.41723 12.4467 3.40967C11.6601 3.4021 11.0172 2.75164 11.0147 1.95748Z"
        fill="white"
      />
      <path
        d="M12.4593 28.5859C13.2635 28.5834 13.924 29.2389 13.9215 30.0356C13.919 30.8247 13.2434 31.4928 12.4517 31.4903C11.6702 31.4853 11.0223 30.8348 11.0147 30.0432C11.0072 29.2263 11.6399 28.5885 12.4593 28.5859Z"
        fill="white"
      />
      <path
        d="M10.3858 5.46536C10.3807 6.27213 9.74542 6.90746 8.94624 6.90494C8.12941 6.8999 7.50671 6.26205 7.51175 5.43259C7.51679 4.62834 8.1521 4.00813 8.96389 4.01569C9.76811 4.02326 10.3908 4.65607 10.3858 5.46536Z"
        fill="white"
      />
      <path
        d="M4.00049 8.92845C4.02066 8.12924 4.6711 7.51156 5.47532 7.53173C6.27198 7.5519 6.88713 8.2074 6.86696 9.01165C6.84679 9.81086 6.18879 10.4361 5.39213 10.4084C4.58538 10.3806 3.98032 9.73774 4.00049 8.92845Z"
        fill="white"
      />
      <path
        d="M8.95883 25.086C9.76809 25.091 10.3883 25.7213 10.3858 26.5306C10.3807 27.3576 9.74792 27.9752 8.92101 27.9626C8.10922 27.95 7.50921 27.3298 7.51173 26.5054C7.51677 25.7012 8.14956 25.0784 8.95883 25.086Z"
        fill="white"
      />
      <path
        d="M5.41949 21.586C6.23128 21.5784 6.85903 22.1911 6.86659 23.0004C6.87668 23.8021 6.25397 24.4374 5.44722 24.4475C4.643 24.4576 4.01021 23.8349 4.00012 23.0281C3.99004 22.2188 4.6077 21.591 5.41949 21.586Z"
        fill="white"
      />
      <path
        d="M3.33873 12.4941C3.33621 13.2807 2.71098 13.911 1.92189 13.916C1.12271 13.9211 0.5 13.2908 0.5 12.4739C0.5 11.6772 1.11766 11.0545 1.90928 11.0469C2.69082 11.0394 3.33873 11.6974 3.33873 12.4941Z"
        fill="white"
      />
      <path
        d="M3.33861 16.0122C3.33357 16.7988 2.70582 17.4215 1.9142 17.4215C1.10493 17.419 0.499872 16.7988 0.504914 15.9769C0.509956 15.1802 1.13266 14.5575 1.92176 14.5625C2.7159 14.5651 3.34113 15.2054 3.33861 16.0122Z"
        fill="white"
      />
      <path
        d="M3.33875 19.515C3.33622 20.3117 2.71856 20.9243 1.91938 20.9243C1.10003 20.9243 0.497487 20.3142 0.500008 19.4898C0.502529 18.6931 1.12776 18.0653 1.91181 18.0703C2.71604 18.0754 3.34127 18.7082 3.33875 19.515Z"
        fill="white"
      />
      <path
        d="M18.1416 26.5154C18.1492 25.7717 18.7517 25.1691 19.4879 25.1641C20.2367 25.1615 20.8468 25.7792 20.8417 26.5356C20.8367 27.2945 20.224 27.892 19.4652 27.8794C18.724 27.8668 18.1366 27.2617 18.1416 26.5154Z"
        fill="white"
      />
      <path
        d="M25.1709 19.5151C25.1659 18.7739 25.7609 18.1612 26.4995 18.1486C27.2508 18.136 27.8735 18.7386 27.8836 19.4924C27.8937 20.2336 27.2685 20.8589 26.5197 20.8589C25.781 20.8589 25.176 20.2563 25.1709 19.5151Z"
        fill="white"
      />
      <path
        d="M26.5309 14.6406C27.2771 14.6432 27.8796 15.2381 27.8847 15.9794C27.8897 16.7231 27.2645 17.3509 26.5208 17.3458C25.7695 17.3433 25.1619 16.7231 25.172 15.9693C25.1796 15.2281 25.7821 14.6381 26.5309 14.6406Z"
        fill="white"
      />
      <path
        d="M24.3516 23.0303C24.344 23.7816 23.749 24.3741 23.0053 24.3716C22.254 24.369 21.6591 23.7589 21.6641 22.9925C21.6666 22.2513 22.2717 21.6512 23.0154 21.6563C23.7717 21.6588 24.3591 22.2614 24.3516 23.0303Z"
        fill="white"
      />
      <path
        d="M26.5273 13.8279C25.7609 13.8279 25.1659 13.2304 25.1709 12.469C25.176 11.7253 25.776 11.1328 26.5222 11.1328C27.276 11.1328 27.8912 11.748 27.8836 12.4968C27.876 13.238 27.276 13.8279 26.5273 13.8279Z"
        fill="white"
      />
      <path
        d="M20.8447 5.44787C20.8497 6.19917 20.2648 6.79921 19.5211 6.80677C18.7522 6.81686 18.1496 6.23195 18.1446 5.47056C18.137 4.71421 18.7497 4.09905 19.4984 4.10157C20.2396 4.10661 20.8396 4.70665 20.8447 5.44787Z"
        fill="white"
      />
      <path
        d="M24.3511 8.98151C24.3461 9.73786 23.7688 10.3152 23.0099 10.3152C22.241 10.3152 21.6586 9.72778 21.6611 8.9563C21.6637 8.19239 22.2612 7.61505 23.0351 7.62513C23.7889 7.63269 24.3562 8.2176 24.3511 8.98151Z"
        fill="white"
      />
      <path
        d="M17.3211 26.5078C17.3237 27.2692 16.7287 27.8718 15.9749 27.8718C15.2286 27.8718 14.6412 27.2844 14.6387 26.5331C14.6337 25.7641 15.2261 25.1615 15.9824 25.1641C16.7211 25.1666 17.3186 25.7666 17.3211 26.5078Z"
        fill="white"
      />
      <path
        d="M13.8118 26.5132C13.8169 27.2519 13.2219 27.862 12.4832 27.8721C11.7294 27.8822 11.1117 27.2746 11.1143 26.5232C11.1168 25.7845 11.7193 25.1795 12.458 25.1719C13.1891 25.1669 13.8043 25.777 13.8118 26.5132Z"
        fill="white"
      />
      <path
        d="M17.3217 5.45839C17.3217 6.22482 16.7317 6.81225 15.9653 6.80721C15.214 6.80217 14.6392 6.21978 14.6367 5.46343C14.6367 4.69952 15.2367 4.09696 15.9905 4.10957C16.7393 4.11965 17.3242 4.7096 17.3217 5.45839Z"
        fill="white"
      />
      <path
        d="M12.458 6.80481C11.7143 6.80481 11.1117 6.20478 11.1143 5.46608C11.1143 4.72738 11.7118 4.12482 12.453 4.11726C13.2017 4.10969 13.8169 4.72486 13.8118 5.47616C13.8043 6.21486 13.2042 6.80481 12.458 6.80481Z"
        fill="white"
      />
      <path
        d="M7.61622 23.0078C7.6137 22.2591 8.20363 21.6666 8.94987 21.6641C9.68603 21.6641 10.2886 22.2666 10.2911 23.0078C10.2911 23.7465 9.68603 24.3516 8.94987 24.3541C8.20111 24.3567 7.61622 23.7642 7.61622 23.0078Z"
        fill="white"
      />
      <path
        d="M8.94987 7.64063C9.70367 7.64315 10.2911 8.23058 10.2886 8.98189C10.2835 9.72563 9.68098 10.3131 8.9297 10.308C8.1885 10.303 7.61874 9.72311 7.61622 8.97685C7.6137 8.21294 8.1885 7.63811 8.94987 7.64063Z"
        fill="white"
      />
      <path
        d="M5.42825 20.8264C4.66941 20.8239 4.07695 20.2289 4.09208 19.4852C4.10721 18.7591 4.70975 18.1641 5.4333 18.1641C6.16441 18.1641 6.78712 18.7969 6.77199 19.5204C6.75686 20.2617 6.17197 20.8264 5.42825 20.8264Z"
        fill="white"
      />
      <path
        d="M5.42817 13.8057C4.67688 13.8057 4.07939 13.2032 4.09199 12.462C4.1046 11.7333 4.70209 11.1484 5.43321 11.1484C6.17441 11.1484 6.78451 11.7636 6.7719 12.4973C6.7593 13.2284 6.16684 13.8057 5.42817 13.8057Z"
        fill="white"
      />
      <path
        d="M5.4441 17.3161C4.69534 17.3211 4.08776 16.7211 4.0928 15.9849C4.09785 15.2538 4.6903 14.6613 5.42141 14.6563C6.16009 14.6512 6.77523 15.2563 6.77271 15.9925C6.77019 16.7211 6.17774 17.3111 5.4441 17.3161Z"
        fill="white"
      />
      <path
        d="M23.0177 11.2266C23.7034 11.2342 24.2656 11.804 24.2631 12.4872C24.2606 13.1705 23.6883 13.7327 23.0026 13.7302C22.2992 13.7276 21.7571 13.1604 21.7697 12.4418C21.7824 11.7636 22.342 11.2191 23.0177 11.2266Z"
        fill="white"
      />
      <path
        d="M21.7715 19.4982C21.774 18.7948 22.3135 18.2553 23.0144 18.2578C23.7052 18.2603 24.2674 18.8226 24.2648 19.5083C24.2623 20.189 23.69 20.7538 23.0043 20.7513C22.3135 20.7513 21.7715 20.1991 21.7715 19.4982Z"
        fill="white"
      />
      <path
        d="M19.4917 10.2172C18.8085 10.2172 18.2337 9.6424 18.2413 8.96421C18.2488 8.27594 18.8136 7.71624 19.4993 7.71876C20.185 7.72128 20.7548 8.29106 20.7498 8.97178C20.7422 9.65753 20.1775 10.2172 19.4917 10.2172Z"
        fill="white"
      />
      <path
        d="M19.4942 21.7734C20.19 21.7734 20.7522 22.3306 20.7472 23.0164C20.7446 23.7021 20.1774 24.2643 19.4942 24.2643C18.8085 24.2643 18.2387 23.6946 18.2412 23.0164C18.2437 22.3256 18.8009 21.7734 19.4942 21.7734Z"
        fill="white"
      />
      <path
        d="M21.7715 16.0005C21.7665 15.2921 22.2959 14.7551 23.0018 14.75C23.6976 14.7475 24.2573 15.2946 24.2649 15.9803C24.2699 16.656 23.6926 17.2434 23.022 17.2434C22.3287 17.246 21.7766 16.6963 21.7715 16.0005Z"
        fill="white"
      />
      <path
        d="M17.2126 23.0138C17.2126 23.7173 16.6781 24.2593 15.9798 24.2593C15.2915 24.2593 14.7344 23.7046 14.7344 23.0164C14.7344 22.3231 15.2814 21.776 15.9773 21.7734C16.6781 21.7734 17.2126 22.3079 17.2126 23.0138Z"
        fill="white"
      />
      <path
        d="M17.2127 8.9847C17.2102 9.68054 16.6555 10.2276 15.9647 10.215C15.2689 10.2024 14.7269 9.64524 14.7345 8.95696C14.7445 8.26365 15.3017 7.71908 15.99 7.72664C16.6807 7.7342 17.2152 8.28382 17.2127 8.9847Z"
        fill="white"
      />
      <path
        d="M13.7001 23.0013C13.7051 23.6921 13.153 24.2518 12.4647 24.2518C11.784 24.2543 11.2143 23.682 11.2168 23.0038C11.2193 22.3332 11.7714 21.7811 12.4471 21.7735C13.1429 21.766 13.695 22.3055 13.7001 23.0013Z"
        fill="white"
      />
      <path
        d="M13.7001 8.9849C13.695 9.67822 13.1379 10.2203 12.4421 10.2102C11.7664 10.2001 11.2219 9.65049 11.2168 8.97482C11.2118 8.29411 11.7816 7.72937 12.4698 7.73441C13.1606 7.73693 13.7051 8.28906 13.7001 8.9849Z"
        fill="white"
      />
      <path
        d="M10.1785 19.4937C10.1811 20.1895 9.63147 20.7442 8.94321 20.7417C8.26504 20.7391 7.71797 20.1946 7.71293 19.5164C7.70788 18.8231 8.25748 18.2709 8.95077 18.2734C9.63651 18.2734 10.176 18.8105 10.1785 19.4937Z"
        fill="white"
      />
      <path
        d="M8.93057 14.7657C9.62387 14.7606 10.1684 15.2825 10.1785 15.9632C10.1886 16.6616 9.65664 17.2162 8.96335 17.2314C8.28518 17.2465 7.71289 16.6817 7.71289 15.9935C7.71289 15.3077 8.24736 14.7707 8.93057 14.7657Z"
        fill="white"
      />
      <path
        d="M10.1785 12.4929C10.176 13.1812 9.64405 13.7081 8.95327 13.7107C8.25241 13.7132 7.71038 13.1711 7.7129 12.4728C7.71794 11.7921 8.25745 11.2525 8.94066 11.25C9.639 11.2475 10.181 11.7921 10.1785 12.4929Z"
        fill="white"
      />
      <path
        d="M19.4919 20.6359C18.8515 20.6359 18.3372 20.1216 18.3448 19.4913C18.3524 18.8786 18.8642 18.3618 19.4818 18.3517C20.102 18.3416 20.639 18.8685 20.644 19.4938C20.6466 20.1241 20.1323 20.6359 19.4919 20.6359Z"
        fill="white"
      />
      <path
        d="M18.3448 12.4655C18.3549 11.8428 18.8994 11.3133 19.5146 11.3284C20.1423 11.3436 20.6592 11.8831 20.6415 12.5058C20.6239 13.1235 20.1045 13.6252 19.4869 13.6227C18.8591 13.6202 18.3372 13.0907 18.3448 12.4655Z"
        fill="white"
      />
      <path
        d="M17.1174 12.4759C17.1224 13.1012 16.6232 13.613 16.0005 13.6231C15.3652 13.6331 14.8433 13.1214 14.8408 12.4885C14.8408 11.8633 15.335 11.3515 15.9577 11.3364C16.5879 11.3187 17.1123 11.8381 17.1174 12.4759Z"
        fill="white"
      />
      <path
        d="M15.9677 20.6361C15.3375 20.631 14.8408 20.1318 14.8408 19.5041C14.8408 18.8637 15.3576 18.3519 15.9904 18.3595C16.6308 18.3695 17.13 18.8864 17.1174 19.5268C17.1022 20.1596 16.6031 20.6411 15.9677 20.6361Z"
        fill="white"
      />
      <path
        d="M11.3282 12.473C11.3332 11.8528 11.8475 11.3359 12.4626 11.3359C13.0803 11.3359 13.5997 11.8528 13.6022 12.4679C13.6072 13.1007 13.0828 13.6226 12.45 13.6151C11.8273 13.6075 11.3231 13.0957 11.3282 12.473Z"
        fill="white"
      />
      <path
        d="M11.3281 15.9914C11.3281 15.3636 11.8298 14.8645 12.4576 14.8594C13.0929 14.8544 13.6097 15.3737 13.6021 16.0091C13.5946 16.6267 13.0752 17.1335 12.4551 17.1284C11.8349 17.1259 11.3256 16.6116 11.3281 15.9914Z"
        fill="white"
      />
      <path
        d="M12.455 20.6338C11.8273 20.6313 11.3281 20.1321 11.3281 19.5043C11.3281 18.8816 11.8323 18.3723 12.455 18.3673C13.0828 18.3597 13.6122 18.8942 13.5996 19.5194C13.587 20.1497 13.0878 20.6363 12.455 20.6338Z"
        fill="white"
      />
      <path
        d="M20.5303 15.9919C20.5278 16.5717 20.074 17.0255 19.4942 17.023C18.9143 17.023 18.4605 16.5667 18.458 15.9893C18.458 15.417 18.9219 14.9506 19.4942 14.9531C20.069 14.9531 20.5303 15.4195 20.5303 15.9919Z"
        fill="white"
      />
      <path
        d="M14.9531 15.9893C14.9531 15.4069 15.4019 14.9531 15.9767 14.9531C16.549 14.9531 17.0103 15.412 17.0128 15.9868C17.0154 16.5616 16.559 17.0179 15.9817 17.0179C15.3968 17.0205 14.9531 16.5742 14.9531 15.9893Z"
        fill="white"
      />
    </svg>
  );
};

export const LogoutIcon = () => (
  <svg
    width="24"
    height="24"
    viewBox="-5 -8 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M16 17L21 12L16 7"
      stroke="currentColor"
      strokeWidth="3"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M21 12H9"
      stroke="currentColor"
      strokeWidth="3"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M12 2H5C3.89543 2 3 2.89543 3 4V20C3 21.1046 3.89543 22 5 22H12"
      stroke="currentColor"
      strokeWidth="3"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const BillingIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
  >
    <path
      fill="currentColor"
      d="M20 4H4c-1.11 0-1.99.89-1.99 2L2 18c0 1.11.89 2 2 2h16c1.11 0 2-.89 2-2V6c0-1.11-.89-2-2-2m0 14H4v-6h16zm0-10H4V6h16z"
    />
  </svg>
);

export const AiReportIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
  >
    <path
      fill="currentColor"
      d="M5 21q-.825 0-1.412-.587T3 19V5q0-.825.588-1.412T5 3h4.2q.325-.9 1.088-1.45T12 1t1.713.55T14.8 3H19q.825 0 1.413.588T21 5v14q0 .825-.587 1.413T19 21zm0-2h14V5H5zm2-2h7v-2H7zm0-4h10v-2H7zm0-4h10V7H7zm5-4.75q.325 0 .538-.213t.212-.537t-.213-.537T12 2.75t-.537.213t-.213.537t.213.538t.537.212M5 19V5z"
    />
  </svg>
);

export const DiscoverIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
  >
    <path
      fill="currentColor"
      d="m8.4 15.6l5.35-2.25q.275-.125.487-.312t.313-.463l2.25-5.35q.125-.3-.112-.537t-.538-.113L10.8 8.825q-.275.125-.487.313t-.313.462L7.75 14.95q-.125.3.113.538t.537.112M12 13q-.425 0-.712-.288T11 12t.288-.712T12 11t.713.288T13 12t-.288.713T12 13m0 9q-2.075 0-3.9-.788t-3.175-2.137T2.788 15.9T2 12t.788-3.9t2.137-3.175T8.1 2.788T12 2t3.9.788t3.175 2.137T21.213 8.1T22 12t-.788 3.9t-2.137 3.175t-3.175 2.138T12 22m0-2q3.35 0 5.675-2.325T20 12t-2.325-5.675T12 4T6.325 6.325T4 12t2.325 5.675T12 20"
    />
  </svg>
);
